import { render, staticRenderFns } from "./activityAdapterFile_zhCH.vue?vue&type=template&id=5620ce6f&scoped=true"
import script from "./activityAdapterFile_zhCH.vue?vue&type=script&lang=js"
export * from "./activityAdapterFile_zhCH.vue?vue&type=script&lang=js"
import style0 from "./activityAdapterFile_zhCH.vue?vue&type=style&index=0&id=5620ce6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620ce6f",
  null
  
)

export default component.exports